import { create, tsx } from '@dojo/framework/core/vdom';
import { Head } from '../../widgets/Head';
import { Text } from '../../widgets/Text';
import Image from '../../widgets/Image';
import Summary from '../../widgets/Summary';
import OpenSourcePage from './OpenSourcePage';

const tsLogo = require('../../assets/images/logo/medium/typescript.svg');

const factory = create();

export const OpenSourceTypescript = factory(function OpenSourceTypescript() {
	return (
		<OpenSourcePage background="level3Blue">
			{{
				head: (
					<Head
						title="TypeScript | SitePen"
						description="SitePen is a strong advocate and supporter of TypeScript, which provides optional typing with intelligent type inference to help enterprise teams build and maintain high-quality applications."
					/>
				),
				hero: {
					title: 'Open Source',
					xlTitle: 'TypeScript'
				},
				page: (
					<Summary stack paddingBottom="md">
						{{
							image: <Image src={tsLogo} size="sm" width={288} height={288} />,
							blurb: (
								<virtual>
									<Text type="large-body">
										We recognized the potential{' '}
										<a
											href="https://www.typescriptlang.org"
											target="_blank"
											rel="noopener"
										>
											TypeScript
										</a>{' '}
										had all the way back in 2013. By embracing rather than
										trying to replace JavaScript, we knew that TypeScript could
										bring significant tooling improvements to the language we
										already loved through its addition of optional typing,
										interfaces, and static analysis tooling. By 2014, we were
										already experimenting with how to utilize TypeScript to
										bring order to the mayhem of large-scale web application
										development.
									</Text>
									<Text type="large-body">
										To us, TypeScript is not a language. It’s a tool used to
										better write JavaScript by providing intelligent code
										completion, refactoring, and validation to applications.
										TypeScript can (and is!) changing the face of web
										application development as we know it.
									</Text>
									<Text type="large-body">
										We continue to be avid proponents of TypeScript, partnering
										with Microsoft to present the first-ever TypeScript
										conference (
										<a href="http://tsconf.io/" target="_blank" rel="noopener">
											TSConf
										</a>
										) starting in 2018, building the modern Dojo Framework, a
										TypeScript-first framework for building enterprise-scale web
										applications and advocating for its use to improve our
										customers’ development organizations. Because of these
										things, we fancy ourselves contributors to its fast growing
										community!
									</Text>
								</virtual>
							)
						}}
					</Summary>
				)
			}}
		</OpenSourcePage>
	);
});

export default OpenSourceTypescript;
